// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__jHYVw","label":"LabeledBox_label__kjjbw"};